<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs1 class="pl-0 pr-0">
              <v-text-field
                v-model="filterSearch"
                label=""
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-select
                :items="filterConsumerItems"
                item-text="text"
                item-value="value"
                v-model="filterConsumerInput"
                label="Application"
                bottom
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-select
                :items="filterContentsItems"
                v-model="filterContentsInput"
                label="Event Type"
                bottom
                @focus.native="getActionList"
                @click.native="getActionList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-text-field
                v-model="filterActorEmail"
                label="Operator Email"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-text-field
                v-model="filterActorName"
                label="Operator Name"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-0 pr-0">
              <v-text-field
                v-model="filterEndTime"
                placeholder="End Time(YYYY-MM-DD HH:mm:ss)"
                single-line
                hide-details
                mask="####-##-## ##:##:##"
                return-masked-value
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-0 pr-0">
              <v-text-field
                v-model="filterStartTime"
                placeholder="Start Time(YYYY-MM-DD HH:mm:ss)"
                single-line
                hide-details
                mask="####-##-## ##:##:##"
                return-masked-value
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-select
                :items="filterHotelItems"
                v-model="filterHotelInput"
                label="Hotel"
                bottom
                @focus.native="getHotelList"
                @click.native="getHotelList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0" v-if="!checkAdminType()">
              <v-select
                :items="filterDomainItems"
                v-model="filterDomainInput"
                label="Domain"
                bottom
                full-width
                @focus.native="getDomainList"
                @click.native="getDomainList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-text-field
                v-model="filterHotelIndex"
                label="Hotel Index"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0" v-if="!checkAdminType()">
              <v-text-field
                v-model="filterDomainIndex"
                label="Domain Index"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { auditLogsEventBus } from '@/components/admin/auditLogs/auditLogsEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter'],
    data() {
      return {
        // NOTE: 모든 검색어
        allSearch: {
          domain_index: {
            search: null,
            searchCategory: 'domain_index',
          },
          hotel_index: {
            search: null,
            searchCategory: 'hotel_index',
          },
          domain: {
            search: null,
            searchCategory: 'domain_id',
          },
          hotel: {
            search: null,
            searchCategory: 'hotel_id',
          },
          startTime: {
            search: null,
            searchCategory: 'startTime',
          },
          endTime: {
            search: null,
            searchCategory: 'endTime',
          },
          actor_name: {
            search: null,
            searchCategory: 'actor_name',
          },
          actor_email: {
            search: null,
            searchCategory: 'actor_email',
          },
          action: {
            search: null,
            searchCategory: 'action',
          },
          consumer: {
            search: null,
            searchCategory: 'consumer',
          },
          search_item: {
            search: null,
            searchCategory: 'search_item',
          },
        },
        valid: true,
        // NOTE: 렌더링 될 변수들
        filterDomainIndex: null,
        filterHotelIndex: null,
        filterDomain: null,
        filterDomainItems: [],
        filterHotel: null,
        filterHotelItems: [],
        filterStartTime: null,
        filterEndTime: null,
        filterActorName: null,
        filterActorEmail: null,
        filterContents: null,
        filterContentsItems: [],
        filterLocation: null,
        filterConsumer: null,
        filterConsumerItems: [
          { text: 'StaffApp', value: 'staff' },
          { text: 'UserApp', value: 'UserApp' },
          { text: 'IGRMS', value: 'IGRMS' },
          { text: 'AdminWeb', value: 'AdminWeb' },
          { text: 'StaffWeb', value: 'StaffWeb' },
        ],
        filterSearch: null,
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'domain_index':
                    this.filterDomainIndex = filter[j].search;
                    break;
                  case 'hotel_index':
                    this.filterHotelIndex = filter[j].search;
                    break;
                  case 'domain_id':
                    this.filterDomain = filter[j].search;
                    this.getDomainList();
                    break;
                  case 'hotel_id':
                    this.filterHotel = filter[j].search;
                    this.getHotelList();
                    break;
                  case 'startTime':
                    this.filterStartTime = filter[j].search;
                    break;
                  case 'endTime':
                    this.filterEndTime = filter[j].search;
                    break;
                  case 'actor_name':
                    this.filterActorName = filter[j].search;
                    break;
                  case 'actor_email':
                    this.filterActorEmail = filter[j].search;
                    break;
                  case 'action':
                    this.filterContents = filter[j].search;
                    this.getActionList();
                    break;
                  case 'consumer':
                    this.filterConsumer = filter[j].search;
                    break;
                  case 'search_item':
                    this.filterSearch = filter[j].search;
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            auditLogsEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      /**
       * @description 필터링 초기화
       */
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 도메인 목록 가져오기
       */
      getDomainList() {
        const query = {
          limit: 1000,
        };
        api.getDomainList(query)
        .then((result) => {
          if (result.status === 200) {
            this.filterDomainItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 호텔 목록 가져오기
       */
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            this.filterHotelItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 액션 목록 가져오기
       */
      getActionList() {
        api.getActionList()
        .then((result) => {
          if (result.status === 200) {
            this.filterContentsItems = result.data.map((action) => {
              const newObj = {};
              newObj.value = action;
              newObj.text = action;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 시간 정규화 체크
       */
      isRegExpTime(time) {
        const regExpTime = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
        if (regExpTime.test(time)) return moment(time).valueOf();
        return null;
      },
      /**
       * @description index 정규화 체크
       */
      isRegExpIndex(index) {
        const regExpIndex = /^[0-9]+$/;
        if (regExpIndex.test(index)) return _.parseInt(index);
        return null;
      },
      /**
       * @description admin type이 root인지 normal인지 체크
       */
      checkAdminType() {
        return localStorage.getItem('domain_type') === 'normal';
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        auditLogsEventBus.$emit('customFilter', obj);
        storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    computed: {
      filterDomainInput: {
        get() {
          return this.filterDomain;
        },
        set(newValue) {
          console.log('filterDomainInput');
          this.filterDomain = newValue;
          this.allSearch.domain.search = newValue;
          auditLogsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterHotelInput: {
        get() {
          return this.filterHotel;
        },
        set(newValue) {
          console.log('filterHotelInput');
          this.filterHotel = newValue;
          this.allSearch.hotel.search = newValue;
          auditLogsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterContentsInput: {
        get() {
          return this.filterContents;
        },
        set(newValue) {
          console.log('filterContentsInput');
          this.filterContents = newValue;
          this.allSearch.action.search = newValue;
          auditLogsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterConsumerInput: {
        get() {
          return this.filterConsumer;
        },
        set(newValue) {
          console.log('filterConsumerInput');
          this.filterConsumer = newValue;
          this.allSearch.consumer.search = newValue;
          auditLogsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
    },
    watch: {
      /**
       * @description 작업을 실행할 수 있는 빈도를 제한합니다
       */
      filterDomainIndex(newValue) {
        console.log('filterDomainIndex');
        this.allSearch.domain_index.search = this.isRegExpIndex(newValue);
        this.getInputValue(this.allSearch);
      },
      filterHotelIndex(newValue) {
        console.log('filterHotelIndex');
        this.allSearch.hotel_index.search = this.isRegExpIndex(newValue);
        this.getInputValue(this.allSearch);
      },
      filterStartTime(newValue) {
        console.log('filterStartTime');
        this.allSearch.startTime.search = this.isRegExpTime(newValue);
        this.getInputValue(this.allSearch);
      },
      filterEndTime(newValue) {
        console.log('filterEndTime');
        this.allSearch.endTime.search = this.isRegExpTime(newValue);
        this.getInputValue(this.allSearch);
      },
      filterActorName(newValue) {
        console.log('filterActorName');
        this.allSearch.actor_name.search = newValue;
        this.getInputValue(this.allSearch);
      },
      filterActorEmail(newValue) {
        console.log('filterActorEmail');
        this.allSearch.actor_email.search = newValue;
        this.getInputValue(this.allSearch);
      },
      filterSearch(newValue) {
        console.log('filterSearch');
        this.allSearch.search_item.search = newValue;
        this.getInputValue(this.allSearch);
      },
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      auditLogsEventBus.$off('initFilter');
      auditLogsEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/auditLogs/AuditLogsFilter.vue